import { tapOnce } from './tap-once';

export { tapOnce };
